import { QueryParams } from '@/common/models';
import ExternalSSP from '@/common/models/misc-api-models/ExternalSSP';
import ErrorHandler from '@/ErrorHandler';
import OrgAppAPIProxy from '@/org-app/api';
import { queryKeys } from '@/org-app/services/tanstack/queryKeys';
import { createGetQuery } from '@/org-app/services/tanstack/queryUtils';
import i18n from '@/vueI18n';

export const useExternalSSPs = createGetQuery<ExternalSSP>(
  [queryKeys.externalSSPs],
  (queryParams: QueryParams) => OrgAppAPIProxy.instance.getExternalSSPs({ queryParams }),
  {
    onError(error) {
      const msg = i18n.global.t('messages.failedToGetExternalSSPs');
      ErrorHandler.showError(msg, error);
    },
  },
);
